import { createMutation } from "@/mutations";
import { thirdPartyLogin } from "@/features/auth/api/session";
import type { ThirdPartyAuthResponse } from "@/features/auth/api/session";
import type { AxiosResponse } from "axios";

type ThirdPartyAuthResponseData = Awaited<
  ReturnType<typeof thirdPartyLogin>
> extends AxiosResponse<infer T>
  ? T
  : never;

export const useThirdPartyAuthMutation = () => {
  return createMutation<ThirdPartyAuthResponseData, string>({
    mutationFn: async (provider) => {
      const response = await thirdPartyLogin(provider);
      return response.data;
    },
  });
};

